import React from 'react';
import { Outlet } from 'react-router-dom';
import { CustomThemeProvider } from './stores/ThemeStore';
import { ConfigurationsProvider } from './stores/ConfigStore';
import { TenantsProvider } from './stores/TenantStore';

const App = () => {
  return (
    <CustomThemeProvider>
      <ConfigurationsProvider>
        <TenantsProvider>
            <Outlet />
        </TenantsProvider>
      </ConfigurationsProvider>
    </CustomThemeProvider>

  );
};

export default App;
